export enum OutputTypeEnum {
    Vorschau, Pdf, Xlsx
};